import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "aft_test_lang";
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "ka";
    return localStorage.getItem(STORAGE_KEY) === "en" ? "en" : "ka";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const toggleLang = () => setLang((l) => (l === "ka" ? "en" : "ka"));
  const t = (node) => (node ? node[lang] ?? node.ka ?? node.en : "");

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
